import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { saveScreenSeat } from '../utils/sessionManager';

/**
 * Component to handle screen and seat parameters from URL
 * This component is rendered when the URL matches /snacks/:screen/:seat
 * It extracts the parameters, saves them to localStorage, and redirects to /snacks
 */
const ScreenSeatHandler = () => {
  // Get screen and seat from URL parameters
  const { screen, seat } = useParams();
  
  useEffect(() => {
    console.log('ScreenSeatHandler: Processing URL parameters');
    console.log('Screen:', screen, 'Seat:', seat);
    
    if (screen && seat) {
      // Save parameters to localStorage
      saveScreenSeat(screen, seat);
      console.log('Parameters saved to localStorage');
      
      // Verify data was saved
      const savedData = localStorage.getItem('screen_seat_data');
      console.log('Saved data:', savedData);
    }
  }, [screen, seat]);
  
  // Redirect to homepage so user can choose Kitchen or Kiosk
  return <Navigate to="/" replace />;
};

export default ScreenSeatHandler;
